export function convertDate(inputFormat: any) {
  function pad(s: number) {
    return s < 10 ? '0' + s : s;
  }
  const d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
}

export function formatTime(timeInSeconds: number): {
  hours?: string;
  minutes: string;
  seconds: string;
} {
  try {
    const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
    return {
      hours: result.substr(0, 2),
      minutes: result.substr(3, 2),
      seconds: result.substr(6, 2),
    };
  } catch (e) {
    return { minutes: '-- ', seconds: ' --' };
  }
}
